/* Kingpong's independent choice controller; Simple still owns the page flow. */
(() => {
  'use strict';
  const BALLS = [
    ['WHITE', '#fff'], ['BLACK', '#000'], ['NEON GREEN', '#b5f600'],
    ['NEON ORANGE', '#ff6500'], ['PURPLE', '#9257bd'], ['PINK', '#f093c8']
  ];
  const TABLES = [
    'kingpong-black-v1-arena',
    'kingpong-black-v2-arena',
    'kingpong-beige-arena'
  ];
  const kind = product => /arena/.test(product.handle) ? 'table' : /4-pack/.test(product.handle) ? 'ball' : 'color';
  const ballName = title => {
    const text = title.toUpperCase();
    return BALLS.find(([name]) => text.includes(name))?.[0] || '';
  };
  const variantForBall = (product, name) => product.variants.find(variant => ballName(variant.title) === name);
  const firstAvailable = product => product?.variants.find(variant => variant.available);
  const buildItems = (variant, table, quantity) => {
    if (!variant?.available) throw new Error('Please choose an available option.');
    if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error('Please choose a valid quantity.');
    if (table && !table.available) throw new Error('The selected table is sold out. Please choose another table.');
    return [variant, ...(table ? [table] : [])].map(item => ({id:item.id, quantity}));
  };
  // Pure selection rules are also exercised without the browser/cart network.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {BALLS, TABLES, kind, ballName, variantForBall, buildItems};
    return;
  }
  const init = () => {
    const root = document.querySelector('[data-ak-kingpong-product="true"]');
    const data = root?.querySelector('[data-ak-kingpong-catalog]');
    if (!root || !data || root.dataset.akKingpongReady === 'true') return;
    root.dataset.akKingpongReady = 'true';
    const catalog = JSON.parse(data.textContent);
    const products = catalog.products;
    let current = products.find(product => product.id === catalog.productId);
    if (!current) return;
    let category = kind(current);
    const previewView = new URL(location.href).searchParams.get('view');
    let variant = current.variants.find(item => item.id === catalog.variantId) || firstAvailable(current) || current.variants[0];
    const tableProducts = products.filter(product => kind(product) === 'table');
    const requestedTable = Number(new URL(location.href).searchParams.get('table'));
    let table = category === 'color'
      ? tableProducts.flatMap(product => product.variants).find(item => item.id === requestedTable && item.available) || null
      : null;
    let adding = false;
    let colorChosen = false, ballChosen = false, tableChosen = false;
    const error = root.querySelector('.ak-kingpong-error');
    const controls = root.querySelector('.ak-kingpong-options');
    const money = value => `${new Intl.NumberFormat('da-DK', {minimumFractionDigits:2, maximumFractionDigits:2}).format(value / 100)} ${catalog.currency}`;
    const syncSelectionURL = () => {
      const url = new URL(current.url, location.origin);
      if (previewView) url.searchParams.set('view', previewView);
      url.searchParams.set('variant',variant.id);
      if (table) url.searchParams.set('table',table.id);
      else url.searchParams.delete('table');
      history.replaceState({},'',url);
    };
    const route = path => `${window.Shopify?.routes?.root || '/'}${path}`;
    const desktop = window.matchMedia('(min-width:1201px)');
    const menus = [...controls.querySelectorAll('.ak-kingpong-option')].map(wrapper => ({
      wrapper, trigger:wrapper.querySelector('.ak-kingpong-trigger'),
      stack:wrapper.querySelector('.ak-kingpong-stack'), rows:wrapper.querySelector('.ak-kingpong-rows'),
      inside:false,open:false,pinned:false,timer:null
    }));
    const setOpen = (menu, open) => {
      clearTimeout(menu.timer);
      menu.open = open;
      menu.trigger.setAttribute('aria-expanded',String(open));
      menu.stack.setAttribute('aria-hidden',String(!open));
      menu.stack.inert = !open;
      menu.stack.hidden = desktop.matches ? false : !open;
      menu.wrapper.classList.toggle('is-open',open);
    };
    const closeAll = () => menus.forEach(menu => {
      menu.pinned=false; menu.inside=false; setOpen(menu,false);
    });
    const row = (group, label, action, options = {}) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'ak-kingpong-row';
      button.disabled = options.disabled || false;
      button.setAttribute('aria-pressed', String(Boolean(options.selected)));
      if (button.disabled) button.setAttribute('aria-label', `${label} — Sold out`);
      const swatch = document.createElement('span');
      swatch.className = 'ak-kingpong-swatch';
      swatch.setAttribute('aria-hidden','true');
      if (options.image) {
        swatch.classList.add('ak-kingpong-thumbnail');
        const image = document.createElement('img');
        image.className = 'ak-kingpong-thumbnail-image';
        image.src = options.image; image.alt = ''; image.loading = 'lazy';
        swatch.append(image);
      } else swatch.style.setProperty('--ak-kingpong-swatch', options.color || 'var(--ak-wall)');
      const text = document.createElement('span'); text.textContent = label;
      button.append(swatch, text);
      button.addEventListener('click', () => { action(); closeAll(); });
      controls.querySelector(`[data-ak-kingpong-group="${group}"] .ak-kingpong-rows`).append(button);
    };
    const selectProduct = (product, selectedVariant) => {
      if (!selectedVariant?.available) return;
      const wasColor = category === 'color';
      current = product;
      colorChosen = true;
      category = kind(product);
      variant = selectedVariant;
      if (!wasColor || category !== 'color') table = null;
      syncSelectionURL();
      root.dataset.akKingpongSelectedProduct = String(product.id);
      document.title = `${product.title} – ARTSY__KID`;
      document.querySelector('link[rel="canonical"]')?.setAttribute('href',new URL(product.url,location.origin).href);
      document.querySelectorAll('.ak-session-one-heading__title > span,.ak-product-title-mobile,.ak-product-title-desktop').forEach(element => { element.textContent=product.title; });
      root.querySelectorAll('input[name="id"]').forEach(input => { input.value=String(variant.id); });
      root.querySelectorAll('.ak-simple-session-one-image,.ak-simple-session-one-wide-image').forEach(image => {
        image.removeAttribute('srcset'); image.src=product.gallery?.[0]?.src || product.hero; image.alt=product.title;
      });
      const storyImage=document.querySelector('.ak-simple-session-2__image');
      if(storyImage){storyImage.removeAttribute('srcset');storyImage.src=product.gallery?.[1]?.src || product.hero;storyImage.alt=product.title;}
      const description=document.querySelector('.ak-simple-session-2__text');
      if(description) description.innerHTML=product.description;
      window.dispatchEvent(new CustomEvent('ak:kingpong-gallery-change',{detail:{images:product.gallery || []}}));
      render(); sync();
      window.dispatchEvent(new Event('resize'));
    };
    const navigate = (product, selectedVariant) => {
      const url = new URL(product.url, location.origin);
      if (selectedVariant) url.searchParams.set('variant', selectedVariant.id);
      if (previewView) url.searchParams.set('view',previewView);
      if (table && kind(product) === 'color') url.searchParams.set('table',table.id);
      location.assign(url.href);
    };
    const sync = () => {
      const total = variant.price + (table?.price || 0);
      const labels = {
        color:colorChosen ? current.title : 'CHOOSE COLOR',
        ball:ballChosen ? ballName(variant.title) : 'BALL COLOR',
        table:tableChosen ? (tableProducts.find(product => product.variants.some(item => item.id === table?.id))?.title || 'NO TABLE') : 'TABLE'
      };
      Object.entries(labels).forEach(([group,label]) => {
        const span=controls.querySelector(`[data-ak-kingpong-group="${group}"] .ak-kingpong-trigger > span`);
        if(span && span.textContent !== label) span.textContent=label;
      });
      root.querySelectorAll('.ak-simple-total-price,.ak-mobile-builder-price,.ak-flow-from-price').forEach(element => {
        const value = table ? money(total) : variant.priceText;
        if (element.textContent !== value) element.textContent = value;
      });
      const label = category === 'color' ? `${current.title} / ${ballName(variant.title)}` : current.title;
      const mobileLabel = root.querySelector('.ak-mobile-builder-total-label');
      if (mobileLabel && mobileLabel.textContent !== label) mobileLabel.textContent = label;
      root.querySelectorAll('button[name="add"],button.add-to-cart,.ak-mobile-basket-trigger').forEach(button => {
        const disabled = adding || !variant.available;
        if (button.disabled !== disabled) button.disabled = disabled;
        if (button.getAttribute('aria-disabled') !== String(disabled)) button.setAttribute('aria-disabled',String(disabled));
      });
    };
    const render = () => {
      controls.querySelectorAll('.ak-kingpong-rows').forEach(list => list.replaceChildren());
      products.filter(product => kind(product) === 'color').forEach(product => {
        const matching = variantForBall(product, ballName(variant.title));
        row('color', product.title, () => {
          if (product.id !== current.id) selectProduct(product, matching?.available ? matching : firstAvailable(product));
        }, {image:product.image, selected:current.id === product.id, disabled:!firstAvailable(product)});
      });
      BALLS.forEach(([name, color]) => {
        const ballProduct = products.find(product => kind(product) === 'ball' && ballName(product.title) === name);
        const choice = category === 'color' ? variantForBall(current, name) : firstAvailable(ballProduct);
        row('ball', name, () => {
          if (category !== 'color') { if (ballProduct) navigate(ballProduct, choice); return; }
          variant = choice;
          ballChosen = true;
          syncSelectionURL();
          root.querySelectorAll('.ak-simple-session-one-image,.ak-simple-session-one-wide-image').forEach(image => {
            image.removeAttribute('srcset'); image.src = current.gallery?.[0]?.src || current.hero;
          });
          render(); sync();
        }, {color, disabled:!choice?.available, selected:category === 'color' ? ballName(variant.title) === name : current.id === ballProduct?.id});
      });
      TABLES.forEach(handle => {
        const product = products.find(product => product.handle === handle);
        if (!product) return;
        const choice = firstAvailable(product);
        row('table', product.title, () => {
          // A table product is a normal Simple page. The game-box action is
          // selected explicitly in the Kingpong configuration.
          if (category === 'color' && catalog.tableMode === 'add') {
            table = choice; tableChosen = true; syncSelectionURL(); render(); sync();
          } else if (product) navigate(product, choice);
        }, {image:product?.image,disabled:!choice,selected:table?.id === choice?.id || current.id === product?.id});
      });
      if (category === 'color') row('table','NO TABLE',() => {
        table=null; tableChosen = true; syncSelectionURL(); render(); sync();
      }, {selected:!table});
      menus.forEach(menu => {
        const rows=[...menu.rows.children];
        rows.forEach((row,index) => row.style.setProperty('--ak-option-row-index',rows.length-1-index));
        menu.wrapper.style.setProperty('--ak-option-row-count',rows.length);
      });
    };
    menus.forEach(menu => {
      const {trigger,wrapper,rows}=menu;
      const enter=()=>{
        window.dispatchEvent(new CustomEvent('ak-desktop-options-intent'));
        clearTimeout(menu.timer);
        menus.forEach(other=>{
          if(other!==menu){other.pinned=false;other.inside=false;setOpen(other,false);}
        });
        setOpen(menu,true);
      };
      trigger.addEventListener('pointerenter',()=>{
        if(!desktop.matches)return;
        menu.inside=true;enter();
      });
      wrapper.addEventListener('pointerleave',()=>{
        if(!desktop.matches)return;
        menu.inside=false;clearTimeout(menu.timer);
        if(menu.pinned)return;
        menu.timer=setTimeout(()=>{if(!menu.inside&&!menu.pinned)setOpen(menu,false);},120);
      });
      trigger.addEventListener('click',()=>{
        if(!desktop.matches){const opening=!menu.open;closeAll();setOpen(menu,opening);return;}
        menus.forEach(other=>{
          other.pinned=false;other.inside=false;if(other!==menu)setOpen(other,false);
        });
        menu.pinned=true;menu.inside=true;enter();
      });
      wrapper.addEventListener('keydown',event=>{
        if(event.key==='Escape'){
          trigger.focus();menu.pinned=false;setOpen(menu,false);event.preventDefault();
        }
        if(event.key==='ArrowUp'||event.key==='ArrowDown'){
          event.preventDefault();enter();
          const available=[...rows.querySelectorAll('button:not(:disabled)')];
          const index=available.indexOf(document.activeElement);
          const next=index<0?available.length-1:(index+(event.key==='ArrowUp'?-1:1)+available.length)%available.length;
          available[next]?.focus();
        }
      });
      setOpen(menu,false);
    });
    document.addEventListener('click',event=>{if(!controls.contains(event.target))closeAll();});
    desktop.addEventListener('change',closeAll);
    const add = async (button, form) => {
      if (adding) return;
      adding = true; sync(); closeAll(); error.hidden = true;
      button?.setAttribute('aria-busy','true');
      try {
        const quantity = Number(form ? new FormData(form).get('quantity') || 1 : 1);
        const items = buildItems(variant, table, quantity);
        const response = await fetch(route('cart/add.js'), {
          method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items,sections:'cart-items,cart-footer,cart-item-count,cart-live-region',sections_url:location.pathname})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Could not add your Kingpong selection.');
        document.body.dispatchEvent(new CustomEvent('baseline:cart:afteradditem',{bubbles:true,detail:{response:result,sourceId:form?.id || 'ak-kingpong'}}));
        window.dispatchEvent(new CustomEvent('ak-open-cart'));
      } catch (failure) {error.textContent=failure.message;error.hidden=false;}
      finally {adding=false;button?.removeAttribute('aria-busy');sync();}
    };
    window.addEventListener('click', event => {
      const button=event.target.closest?.('[data-ak-kingpong-product="true"] :is(button[name="add"],button.add-to-cart,.ak-mobile-basket-trigger)');
      if (!button || button.disabled) return;
      event.preventDefault();event.stopImmediatePropagation();add(button,button.form || button.closest('form'));
    },true);
    window.addEventListener('submit', event => {
      if (!event.target.closest?.('[data-ak-kingpong-product="true"]')) return;
      if (!new URL(event.target.action,location.origin).pathname.endsWith('/cart/add')) return;
      event.preventDefault();event.stopImmediatePropagation();add(event.submitter,event.target);
    },true);
    document.addEventListener('theme:variant:change', event => {
      if (!root.contains(event.detail?.productRootEl)) return;
      const next=current.variants.find(item=>item.id===event.detail?.variant?.id);
      if (next) {variant=next;render();sync();}
    });
    const observer = new MutationObserver(sync);
    observer.observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
    render();sync();
    window.addEventListener('ak-configurator-built',sync);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
